// Founder, 2026-11-04: the company pages moved from /app/... to the root (app.ernd.ai/card/apply, not
// app.ernd.ai/app/card/apply). Old links (emails, ernd.io buttons, bookmarks, sign-in next=) keep working through one
// table. The server has the same table (pr/core/paths.py: its page fallback 301s, and sign-in maps next=); keep them
// equal.
//
// Every /app/<x> becomes /<x>, query kept, except:
// - /app becomes /.
// - /app/partners and below become /directory and below: /partners is already the partner sign-in short link.
// - Pages that are gone open a live page and drop the query: /app/setup (and below), /app/assistant -> /card;
//   /app/agent -> /.
const RENAMED: Record<string, string> = { '/app/partners': '/directory' }
const GONE: Record<string, string> = { '/app/setup': '/card', '/app/assistant': '/card', '/app/agent': '/' }
const under = (path: string, p: string) => path === p || path.startsWith(`${p}/`)

/** Where an old app path (with or without ?query) lives now, or null when it isn't one. */
export function moved(value: string | null | undefined): string | null {
  if (!value) return null
  const [path, ...rest] = value.split('?')
  const query = rest.join('?')
  if (!under(path, '/app')) return null
  const bare = path.replace(/\/+$/, '') || '/'
  for (const [old, to] of Object.entries(GONE)) if (under(bare, old)) return to
  let next = path.slice('/app'.length) || '/'
  for (const [old, to] of Object.entries(RENAMED)) if (under(bare, old)) next = to + path.slice(old.length)
  if (next.startsWith('//') || next.includes('\\')) return '/'
  return query ? `${next}?${query}` : next
}

/** value with an old app path swapped for its new one; anything else unchanged. */
export const current = <T extends string | null | undefined>(value: T): T | string => moved(value) ?? value

// The company side: the home page (/ exactly) and these pages and everything under them.
export const COMPANY_HOME = '/'
export const COMPANY_PAGES = ['/card', '/new', '/join', '/team', '/profile', '/claims', '/invoices', '/redeem',
  '/redemptions', '/travel', '/bank-return']
export const isCompanyPage = (pathname: string) => pathname === COMPANY_HOME || COMPANY_PAGES.some((p) => under(pathname, p))
